import { useState } from 'react';
import { Button } from '../ui/button';
import { ScanText, Check } from 'lucide-react';
import { cpdAPI, errMsg } from '../../lib/cpdRegisterAPI';
import { toast } from 'sonner';

const TONE = { High: 'text-emerald-700', Medium: 'text-amber-700', Low: 'text-rose-700' };
const LBL = { name: 'Name', title: 'Activity', provider: 'Provider', date: 'Date', hours: 'Hours', certificate_number: 'Certificate no.' };

// Offers "Read certificate" for a selected PDF; nothing is applied until the user confirms.
export const CPDCertificateReader = ({ file, onApply }) => {
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  if (!file) return null;
  const read = async () => { setBusy(true); try { setRes(await cpdAPI.readCertificate(file)); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  const apply = () => { onApply(Object.fromEntries(Object.entries(res.fields).filter(([k]) => k !== 'name').map(([k, v]) => [k, String(v.value)]))); setRes(null); };
  return (
    <div className="rounded-xl border border-dashed p-3 space-y-2" data-testid="cpd-cert-reader">
      <Button type="button" size="sm" variant="outline" onClick={read} disabled={busy} data-testid="cpd-cert-read"><ScanText className="w-4 h-4 mr-1" />{busy ? 'Reading…' : 'Read certificate'}</Button>
      {res && (
        <div className="text-sm space-y-1" data-testid="cpd-cert-result">
          <p className="font-semibold">{res.note} <span className="text-xs font-normal text-muted-foreground">({res.method})</span></p>
          {!res.readable || !Object.keys(res.fields).length ? <p className="text-muted-foreground">Couldn't read text; enter manually.</p> : (
            <>{Object.entries(res.fields).map(([k, v]) => <p key={k}>{LBL[k] || k}: <b>{String(v.value)}</b> <span className={`text-xs ${TONE[v.confidence]}`}>{v.confidence}</span></p>)}
              <Button type="button" size="sm" onClick={apply} data-testid="cpd-cert-apply"><Check className="w-4 h-4 mr-1" />Use these values</Button></>
          )}
        </div>
      )}
    </div>
  );
};
